import { TABLES } from "../db";
import { BaseLocalRepository } from "./BaseLocalRepository";

export class LocalSyncOperationRepository extends BaseLocalRepository {
  constructor(db) {
    super(db, TABLES.SYNC_OPERATIONS);
  }

  async listByStatus(status) {
    return this.table.where("status").equals(status).toArray();
  }

  async listByEntity(entityType, entityId) {
    return this.table.where("[entityType+entityId]").equals([entityType, entityId]).toArray();
  }

  async listByOrganizationAndVessel(organizationId, vesselId) {
    return this.table
      .where("[organizationId+vesselId]")
      .equals([organizationId, vesselId])
      .toArray();
  }
}
